/**
 * /frontend/src/features/analytics/components/queue/QueuePerformanceKPIs.js
 */

import React, { useMemo } from 'react';
import KPICardRow from '../shared/KPICardRow';
import { formatMinutes, formatPercent } from '../../utils/formatters';

/**
 * Queue KPI cards row.
 * @param {{performance:any}} props
 * @returns {JSX.Element}
 */
const QueuePerformanceKPIs = ({ performance }) => {
  const items = useMemo(() => ([
    { key: 'avgWait', label: 'Avg wait', value: formatMinutes(performance?.avgWaitMinutes) },
    { key: 'medianWait', label: 'Median wait', value: formatMinutes(performance?.medianWaitMinutes) },
    { key: 'throughput', label: 'Throughput/hr', value: String(performance?.throughputPerHour ?? 0) },
    { key: 'abandon', label: 'Abandonment', value: formatPercent(performance?.abandonmentRate) },
    { key: 'convert', label: 'Conversion', value: formatPercent(performance?.conversionRate) }
  ]), [performance]);

  return <KPICardRow items={items} />;
};

export default QueuePerformanceKPIs;

